import type { AppNotification } from '../api/notificationsApi';

export function parseNotificationData(data: AppNotification['data']): Record<string, unknown> {
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return data as Record<string, unknown>;
  }
  if (typeof data === 'string' && data.trim()) {
    try {
      return JSON.parse(data) as Record<string, unknown>;
    } catch {
      return {};
    }
  }
  return {};
}

export function notificationTypeEmoji(type: string): string {
  switch (type) {
    case 'CHAT_MESSAGE':
      return '💬';
    case 'BOOKING_CONFIRMATION':
    case 'BOOKING_CANCELLATION':
      return '📅';
    case 'CONSTRUCTION_REGISTRATION':
    case 'CONSTRUCTION_CONFIRMATION':
    case 'CONSTRUCTION_CANCELLATION':
    case 'CONSTRUCTION_START':
    case 'CONSTRUCTION_COMPLETION':
    case 'CONSTRUCTION_DEPOSIT':
    case 'CONSTRUCTION_DEPOSIT_REFUND':
      return '🏗️';
    case 'FEE_NOTIFICATION':
      return '💰';
    case 'PAYMENT_CONFIRMATION':
      return '✅';
    case 'TASK_ASSIGNMENT':
    case 'TASK_UPDATE':
      return '📋';
    case 'FEEDBACK_RESPONSE':
      return '💭';
    case 'SYSTEM_ANNOUNCEMENT':
    case 'GENERAL':
      return '📢';
    default:
      return '🔔';
  }
}

export function formatNotificationTime(createdAt: string): string {
  try {
    const dateTime = new Date(createdAt);
    const now = new Date();
    const diffMs = now.getTime() - dateTime.getTime();
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days} ngày trước`;
    if (hours > 0) return `${hours} giờ trước`;
    if (minutes > 0) return `${minutes} phút trước`;
    return 'Vừa xong';
  } catch {
    return '';
  }
}

export function formatNotificationDateTime(createdAt: string): string {
  try {
    return new Date(createdAt).toLocaleString('vi-VN');
  } catch {
    return createdAt;
  }
}
